function slidersix(options) {
  var min = options.min;
  var max = options.max;
  var steps = options.steps;
  var el = options.target;
  var maxDescription = options.maxDescription;
  var minDescription = options.minDescription;
  var initialValue = options.initialValue;

  let root = $('<div class="slider6-container"></div>');

  min = min || 0;
  max = max || 10;
  steps = steps || 1;

  let rangeInput = `<input class="slider6 blank" type="range" min="${min}" max="${max}" steps="${steps}" />`;
  let rangeValue = `<input type="number" style="display:none" />`;
  let currentValue = `<label class="slider6-position"></label>`;
  let descriptions = `<div class="slider6-descriptions"></div>`;

  let labels = '';
  for (let i = min; i < max + 1; i += steps) {
    labels += `<label class="slider6-label" value="${i}">${i}</label>`;
  }

  let labelsRoot = $(`<div class="slider6-labels">${labels}</div>`).appendTo(root);

  if (steps > 1) {
    currentValue = $(currentValue).appendTo(root);
  }

  rangeInput = $(rangeInput).appendTo(root);
  rangeValue = $(rangeValue).appendTo(root);
  descriptions = $(descriptions).appendTo(root);

  descriptions.append(`<div class="slider6-descriptions-min">${minDescription || ''}</div>`);
  descriptions.append(`<div class="slider6-descriptions-max">${maxDescription || ''}</div>`);

  $(el).append(root);

  var defaultValue = rangeInput.val();
  var manuallySetInitialValueOnClick = (e) => {
    // Highlight selected label
    rangeInput.trigger('input');

    if (defaultValue === rangeInput.val()) {
      rangeValue.val(rangeInput.val());
      rangeValue.trigger('change');
    }

    rangeInput.off('touchend', manuallySetInitialValueOnClick);
    rangeInput.off('mouseup', manuallySetInitialValueOnClick);
  };

  var showSliderThumb = () => {
    rangeInput.removeClass('blank');
    rangeInput.off('mousedown', showSliderThumb);
    rangeInput.off('touchstart', showSliderThumb);
  };

  var labelClick = (e) => {
    var value = $(e.currentTarget).attr('value');
    rangeInput.val(value);
    showSliderThumb();
    rangeInput.trigger('input');
    rangeInput.trigger('change');
  };

  // input even is called on drag
  rangeInput.on('input', (e) => {
    // Highlight selected label
    labelsRoot.find('label').removeClass('selected').filter(`label[value="${e.currentTarget.value}"]`).addClass('selected');

    // If inner value is != null, then there's no need to set on mouseup/touchend.
    if (rangeValue.val()) {
      rangeInput.off('mouseup', manuallySetInitialValueOnClick);
      rangeInput.off('touchend', manuallySetInitialValueOnClick);
    }
  });

  rangeInput.on('touchstart', showSliderThumb);
  rangeInput.on('touchend', manuallySetInitialValueOnClick);
  rangeInput.on('mousedown', showSliderThumb);
  rangeInput.on('mouseup', manuallySetInitialValueOnClick);

  rangeInput.on('change', (e) => {
    rangeValue.val(e.currentTarget.value);
    rangeValue.trigger('change');
  });

  if (steps > 1) {
    rangeInput.on('input', (e) => {
      const v = e.currentTarget.value;
      currentValue.text(v);
    });
  }

  if (initialValue != null && initialValue != undefined) {
    rangeInput.val(initialValue);
    rangeValue.val(initialValue);
    rangeInput.trigger('input');
    showSliderThumb();
  }

  labelsRoot.find('label').on('mousedown', labelClick).on('touchstart', labelClick);

  return {
    valueElement: rangeValue.get(),
  };
}
